import { SendEmail } from 'ui/icons/node/SendEmail';
import { SendInApp } from 'ui/icons/node/SendInApp';
import { SendPush } from 'ui/icons/node/SendPush';
import { SendSMS } from 'ui/icons/node/SendSMS';
import { SendWebPush } from 'ui/icons/node/SendWebPush';
import { GoalAnalyticsMetricKey, MediumEnum } from 'modules/iterableGoals/types';
import { MessageMedium } from 'constants/messageMediums';
import { TFunction } from 'react-i18next';
import { localizeCurrencyValue } from 'utils/i18nHelpers';
import { Point } from 'highcharts';
import { CampaignTypeDefinitions } from 'modules/graphql/types';

export const getMediumIcon = (medium: MediumEnum | MessageMedium) =>
  ({
    [MediumEnum.EMAIL]: SendEmail,
    [MediumEnum.PUSH]: SendPush,
    [MediumEnum.SMS]: SendSMS,
    [MediumEnum.IN_APP]: SendInApp,
    [MessageMedium.InApp]: SendInApp,
    [MediumEnum.WEB_PUSH]: SendWebPush,
    [MessageMedium.WebPush]: SendWebPush,
  })[medium];

export const getMediumLabel = (t: TFunction, medium: MediumEnum) =>
  ({
    [MediumEnum.EMAIL]: t('labels.mediums.Email'),
    [MediumEnum.SMS]: t('labels.mediums.SMS'),
    [MediumEnum.IN_APP]: t('labels.mediums.InApp'),
    [MediumEnum.PUSH]: t('labels.mediums.Push'),
    [MediumEnum.WEB_PUSH]: t('labels.mediums.WebPush'),
  })[medium];

export function currencyLabelFormatter(this: { value: number }): string {
  return localizeCurrencyValue(this.value, { notation: 'compact' });
}

export function pointFormatter(isRevenue: boolean) {
  return function formatter(this: Point) {
    const { y: value, series } = this;

    return `${series.name}: <b>${
      isRevenue && GoalAnalyticsMetricKey.REVENUE === series.name
        ? localizeCurrencyValue(value || 0)
        : value
    }</b><br/>`;
  };
}

/**
 * Prints the launched on date text based on the campaign type.
 *
 * @param t - Tfunction: iterableGoals namespace
 * @param type - CampaignTypeDefinitions: Campaign Type
 * @param launchDate - string: Campaign startAt date
 * @param preText - boolean: Decides whether to add the 'Launched on' preText
 * @returns
 */
export const printCampaignLaunchDate = (
  t: TFunction,
  type: CampaignTypeDefinitions,
  launchDate: string,
  preText = true,
) => {
  const campaignLaunch = t<string, Record<string, string>>(
    'labels.performantCampaigns.campaignLaunch',
    { returnObjects: true, launchDate },
  );

  let campaignLaunchText = campaignLaunch[type];
  if (!campaignLaunchText) {
    const launchDateText = preText ? campaignLaunch.launched : launchDate;
    campaignLaunchText = launchDate ? launchDateText : campaignLaunch.not_launched;
  }

  return campaignLaunchText;
};
